export const WalletSummaryCard = (activityPoints, starPoints) => {
    return `
        <div class="grid grid-cols-2 gap-3">
            <div class="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl p-4 text-white shadow-lg relative overflow-hidden">
                <div class="absolute -right-2 -top-2 text-white/10">
                        <span class="material-symbols-outlined text-6xl">savings</span>
                </div>
                <p class="text-indigo-100 text-xs font-bold uppercase mb-1">${window.locale.t('wallet.assets.activity_label')}</p>
                <h3 class="text-2xl font-black">${activityPoints.toLocaleString()} P</h3>
                <p class="text-[10px] text-indigo-200 mt-2">${window.locale.t('wallet.assets.activity_desc')}</p>
            </div>
            <div class="bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl p-4 text-white shadow-lg relative overflow-hidden">
                <div class="absolute -right-2 -top-2 text-white/10">
                        <span class="material-symbols-outlined text-6xl">star</span>
                </div>
                <p class="text-yellow-100 text-xs font-bold uppercase mb-1">${window.locale.t('wallet.assets.star_label')}</p>
                <h3 class="text-2xl font-black">${starPoints.toLocaleString()} STAR</h3>
                <p class="text-[10px] text-yellow-100 mt-2">${window.locale.t('wallet.assets.star_desc')}</p>
            </div>
        </div>
    `;
};
